<template>
    <div style="background-color: #fffc; backdrop-filter: blur(100px); display: flex; flex-direction: column;">
        <MercenaryHeader :isBlur="true" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <template v-if="step === 1">
            <div style="flex: 1; margin-top: 80px; display: flex; flex-direction: column; align-items: center;">
                <div>
                    <img style="width: 91px;" :src="require('@/assets/img/youth_cert.png')" alt="">
                </div>
                <div style="text-align: center; margin-top: 20px; font-weight: 700; font-size: 20px; line-height: 32px;">유소년 회원은 부모님 혹은 가족의<br>결제 확인을 받아야 해요</div>
                <div style="margin-top: 40px;">
                    <div style="width: 300px; padding: 12px; border-radius: 12px; background: #210F031A;">
                        <div style="font-weight: 700; font-size: 14px; line-height: 16px; margin-bottom: 4px;">다음 내용을 꼭 따라해주세요👀</div>
                        <div class="wrapper">
                            <div class="title">1.</div>
                            <div class="contents"><span style="font-weight: 700;">[가족 허락받기]</span> 버튼을 눌러 가족(부모님 및 법정대리인)임을 인증 받으세요.</div>
                        </div>
                        <div class="wrapper">
                            <div class="title">2.</div>
                            <div class="contents">가족 정보를 등록하고 결제를 요청하세요.</div>
                        </div>
                        <div class="wrapper">
                            <div class="title">3.</div>
                            <div class="contents">메시지로 전송된 '결제 내용'을 확인해달라고 꼭 전달하세요.</div>
                        </div>
                        <div class="wrapper">
                            <div class="title">4.</div>
                            <div class="contents">가족이 결제를 완료하면 끝이예요.</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="step === 2">
            <div style="flex: 1; margin-top: 110px; padding: 0 12px;">
                <div style="text-align: center; margin-top: 20px; font-weight: 700; font-size: 20px; line-height: 32px;">부모님 혹은 법정대리인의<br>본인 확인이 필요해요</div>
                <div style="margin-top: 20px;">
                    <div style="padding: 12px; background: #210F030D; border-radius: 12px;">
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px;">부모님 및 법정대리인</div>
                        <input v-model="name" style="width: 100%; outline: none; background-color: transparent; border: none; margin-top: 4px; font-size: 18px; line-height: 32px; font-weight: 500;" placeholder="이름" type="text">
                    </div>
                    <div style="padding: 12px; background: #210F030D; border-radius: 12px; margin-top: 12px;">
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px;">전화번호</div>
                        <input v-model="phone" style="width: 100%; outline: none; background-color: transparent; border: none; margin-top: 4px; font-size: 18px; line-height: 32px; font-weight: 500;" placeholder="숫자만 입력하세요" type="tel">
                    </div>
                    <div v-if="isShowCertNumberBox" style="padding: 12px; background: #210F030D; border-radius: 12px; margin-top: 12px;">
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px;">인증코드</div>
                        <input v-model="certNumber" style="width: 100%; outline: none; background-color: transparent; border: none; margin-top: 4px; font-size: 18px; line-height: 32px; font-weight: 500;" placeholder="숫자만 입력하세요" type="tel">
                    </div>
                </div>
                <div v-if="!isShowCertNumberBox" @click="submitCert" :class="phone === '' || name === '' ? 'disable' : ''" style="margin-bottom: 0;" class="common_btn">보내기</div>
                <div @click="confirmCert" v-else style="margin-bottom: 0;" class="common_btn">확인</div>
                <div style="margin-top: 12px; font-size: 12px; font-weight: 500; line-height: 14px; color: #606060; text-align: center;">가족 인증은 딱 한번만 하면 됩니다!</div>
            </div>
        </template>
        <template v-else-if="step === 3 && isCert">
            <div style="flex: 1; margin-top: 184px;">
                <div style="text-align: center; margin-top: ;">
                    <img style="width: 94px;" :src="require('@/assets/img/cert_complete.png')" alt="">
                </div>
                <div style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 20px; text-align: center;">본인 확인이 완료됐습니다</div>
            </div>
        </template>
        <template v-else-if="step === 3 && !isCert">
            <div style="flex: 1; margin-top: 50px;">
                <div style="text-align: center; margin-top: ;">
                    <img style="width: 40px" :src="require('@/assets/img/cert_fail.png')" alt="">
                </div>
                <div style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 20px; text-align: center;">가족 인증에 실패했습니다.</div>
                <div style="text-align: center; font-size: 12px; font-weight: 500; line-height: 32px; margin-top: 6px; color: #606060;">이유: 본인 인증 대상이 미성년자입니다.</div>
            </div>
        </template>
        <template v-else-if="step === 4">
            <div style="flex: 1; margin-top: 110px; display: flex; flex-direction: column; align-items: center;">
                <div style="text-align: center; margin-top: 20px; font-weight: 700; font-size: 20px; line-height: 32px;">회원님의 가족 정보를 등록했어요<br>이제 결제를 요청하세요</div>
                <div style="margin-top: 20px; background: #210F030D; border-radius: 20px; padding: 20px; width: 290px; text-align: center;">
                    <div style="font-weight: 700; line-height: 32px; color: #606060;">내 가족 정보</div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 14px; color: #606060; margin-bottom: 16px;">앞으로 이 연락처로 결제 요청이 전달됩니다.</div>
                    <img style="width: 80px;" :src="require('@/assets/img/my_family.png')" alt="">
                    <div style="margin-top: 16px;">
                        <div style="border-radius: 8px; background: #210F031A; padding: 4px 12px; text-align: left;">
                            <div style="font-weight: 700; font-size: 12px; line-height: 24px;">이름</div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{family.nic_name}}</div>
                        </div>
                        <div style="border-radius: 8px; background: #210F031A; padding: 4px 12px; margin-top: 8px; text-align: left;">
                            <div style="font-weight: 700; font-size: 12px; line-height: 24px;">연락처 정보</div>
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{family.phone}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="step === 5">
            <div style="flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <div style="font-weight: 500; font-size: 20px; line-height: 24px;">결제를 기다리는 중</div>
                <!-- <div style="display: flex; margin-top: 20px; gap: 6px; align-items: center;">
                    <div class="1" style="width: 16px; height: 16px; border-radius: 50%; background-color: #BBBBBB;"></div>
                    <div class="2" style="display: flex; gap: 6px;">
                        <div style="width: 4px; height: 4px; border-radius: 50%; background-color: #d9d9d9;"></div>
                        <div style="width: 4px; height: 4px; border-radius: 50%; background-color: #d9d9d9;"></div>
                        <div style="width: 4px; height: 4px; border-radius: 50%; background-color: #d9d9d9;"></div>
                    </div>
                    <div class='3' style="width: 16px; height: 16px; border-radius: 50%; background-color: #BBBBBB;"></div>
                    <div class="4" style="display: flex; gap: 6px;">
                        <div style="width: 4px; height: 4px; border-radius: 50%; background-color: #d9d9d9;"></div>
                        <div style="width: 4px; height: 4px; border-radius: 50%; background-color: #d9d9d9;"></div>
                        <div style="width: 4px; height: 4px; border-radius: 50%; background-color: #d9d9d9;"></div>
                    </div>
                    <div class="5" style="width: 16px; height: 16px; border-radius: 50%; background-color: #BBBBBB;"></div>
                </div> -->
                <div style="display: flex; margin-top: 20px; gap: 6px; align-items: center;">
                    <div :style="circle1Style" class="circle1"></div>
                    <div class="dots1" style="display: flex; gap: 6px;">
                        <div v-for="(dot, index) in dots1" :key="index" :style="dot.style"></div>
                    </div>
                    <div :style="circle3Style" class="circle3"></div>
                    <div class="dots2" style="display: flex; gap: 6px;">
                        <div v-for="(dot, index) in dots2" :key="index" :style="dot.style"></div>
                    </div>
                    <div :style="circle5Style" class="circle5"></div>
                </div>
            </div>
        </template>
        <div style="padding: 0 12px;">
            <div v-if="!isCert" style="display: flex; flex-direction: column; align-items: center; margin-bottom: 12px;">
                <img style="width: 56px;" :src="require('@/assets/img/soccerhow_text.png')" alt="">
                <div style="font-weight: 500; font-size: 10px; line-height: 12px; margin-top: 4px; color: #606060;">사커하우 유소년 가족 인증 서비스</div>
            </div>
            <div @click="showPhoneCert" v-if="step !== 3 && step !== 4" :style="{ visibility: step === 1 ? '' : 'hidden' }" class="common_btn">가족 허락받기</div>
            <div @click="nextStep(4)" v-if="step === 3 && isCert" class="common_btn">다음</div>
            <div @click="() => { $GlobalStore.closeLastModal() }" v-if="step === 3 && !isCert" class="common_btn">돌아가기</div>
            <div @click="actionBeforePayRequest" v-if="step === 4" class="common_btn">결제 요청하기</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import { INNOPAY_PAY_METHOD } from '../../modules/InnoPay';
import ResponseCode from '@/ResponseCode';
import {DIRECT_MESSAGE_REQUEST_PRICE} from "../../Constants";

export default {
    name: 'YouthCertificationForm',
    components: {
        MercenaryHeader
    },
    props: {
        step: {
            type: Number,
            default: 1
        },
        isCert: {
            type: Boolean,
            default: false
        },
        direct_message_idx: {
            type: Number,
            defualt: -1
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        selectedTeam: {
            type: Object,
            default: () => { }
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        }
    },
    computed: {
        circle1Style() {
            return {
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: this.circle1Color,
                transition: 'all'
            };
        },
        circle3Style() {
            return {
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: this.circle3Color,
                transition: 'all'
            };
        },
        circle5Style() {
            return {
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: this.circle5Color,
                transition: 'all'
            };
        }
    },
    data() {
        return {
            isShowBtn: true,
            name: '',
            phone: '',
            certNumber: '',
            isShowCertNumberBox: false,
            circle1Color: '#BBBBBB',
            circle3Color: '#BBBBBB',
            circle5Color: '#BBBBBB',
            dots1: [
                { style: { width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#d9d9d9', opacity: 0, transition: 'all .2s' } },
                { style: { width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#d9d9d9', opacity: 0, transition: 'all .2s' } },
                { style: { width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#d9d9d9', opacity: 0, transition: 'all .2s' } }
            ],
            dots2: [
                { style: { width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#d9d9d9', opacity: 0, transition: 'all .2s' } },
                { style: { width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#d9d9d9', opacity: 0, transition: 'all .2s' } },
                { style: { width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#d9d9d9', opacity: 0, transition: 'all .2s' } }
            ],
            currentStep: 1,
            animationLoop: null,
            checkPaidLoop: null,
            family : {},
        }
    },
    mounted() {
        if (this.step === 5) {
            this.startAnimation()

            // const payMethodObj = {
            //     pay_method: INNOPAY_PAY_METHOD,
            //     goods_name: '다이렉트 요청서 보내기',
            //     amt: 20000
            // }
            // setTimeout(() => {
            //     this.$GlobalStore.addModal('CompletePayNew', { payMethodObj: payMethodObj, isModalBackTransparent: true })
            // }, 2000)
        }
    },
    beforeDestroy() {
        clearInterval(this.checkPaidLoop);
        clearInterval(this.animationLoop)
    },
    methods: {
        actionBeforePayRequest(){
            this.completeAction();
            // this.nextStep(5);
        },
        async checkPaid() {
            const parameters = {};
            parameters.direct_message_idx = this.direct_message_idx;
            console.log(this.selectedTeam)
            const res = await this.$Axios.get('/api/pay/direct/message/wait', { params: parameters });
            if (res.data.is_paid) {
                clearInterval(this.checkPaidLoop);
                clearInterval(this.animationLoop)
                const payMethodObj = {
                    pay_method: INNOPAY_PAY_METHOD,
                    goods_name: '다이렉트 요청서 보내기',
                    amt: DIRECT_MESSAGE_REQUEST_PRICE,
                    pay_info: res.data.pay_info
                }
                // await this.completeAction()
                this.$GlobalStore.addModal('CompletePayNew', { payMethodObj: payMethodObj, isModalBackTransparent: true, isShowPopup: true, selectedTeam: this.selectedTeam, soccerhowIdx: this.soccerhowIdx })
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg)
            }


            // 테스트용 위에가 진짜
            // if (res.data.code === 0) {
            //     clearInterval(this.checkPaidLoop)
            //     clearInterval(this.animationLoop)
            //     const payMethodObj = {
            //         pay_method: INNOPAY_PAY_METHOD,
            //         goods_name: '다이렉트 요청서 보내기',
            //         amt: 20000
            //     }
            //     this.completeAction()
            //     this.$GlobalStore.addModal('CompletePayNew', { payMethodObj: payMethodObj, isModalBackTransparent: true, completeAction: this.completeAction, isShowPopup: true })
            // } else if (res.data.code === ResponseCode.FAIL) {
            //     this.$GlobalStore.showAlert(res.data.msg)
            // }

        },
        startAnimation() {
            this.animationLoop = setInterval(() => {
                this.test();
            }, 1000); // 각 단계마다 1초 간격
            this.checkPaidLoop = setInterval(() => {
                this.checkPaid()
            }, 5000)
        },
        test() {
            switch (this.currentStep) {
                case 1:
                    this.circle1Color = '#76d826';
                    this.currentStep = 2;
                    break;
                case 2:
                    this.dots1.forEach((dot, index) => {
                        setTimeout(() => {
                            dot.style.opacity = '1'
                        }, index * 300); // 각 점마다 0.3초 간격
                    });
                    this.currentStep = 3;
                    break;
                case 3:
                    this.circle3Color = '#5C9DFF';
                    this.currentStep = 4;
                    break;
                case 4:
                    this.dots2.forEach((dot, index) => {
                        setTimeout(() => {
                            dot.style.opacity = '1'
                        }, index * 300); // 각 점마다 0.3초 간격
                    });
                    this.currentStep = 5;
                    break;
                case 5:
                    this.circle5Color = '#ff7111';
                    this.currentStep = 6;
                    break;
                case 6:
                    // 모든 과정이 완료되면 초기 상태로 돌아감
                    this.resetAnimation();
                    this.currentStep = 1;
                    break;
            }
        },
        resetAnimation() {
            this.circle1Color = '#BBBBBB';
            this.circle3Color = '#BBBBBB';
            this.circle5Color = '#BBBBBB';
            this.dots1.forEach(dot => {
                dot.style.opacity = '0'
            });
            this.dots2.forEach(dot => {
                dot.style.opacity = '0'
            });
        },
        payAction() {
            this.$GlobalStore.addModal('')
        },
        nextStep(step) {
            this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, step: step, completeAction : this.completeAction })
        },
        submitCert() {
            if (this.name === '') {
                this.$GlobalStore.showAlert('부모님 및 법정대리인의 이름을 입력해주세요.')
                return
            }

            if (this.phone === '') {
                this.$GlobalStore.showAlert('전화번호를 입력해주세요.')
                return
            }
            this.isShowCertNumberBox = true
        },
        confirmCert() {
            if (this.certNumber === '') {
                this.$GlobalStore.showAlert('인증코드를 입력해주세요.')
                return
            }

            let test = true

            if (test) {
                this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, step: 3, isCert: true, completeAction : this.completeAction })
            } else {
                this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, step: 3, isCert: false, completeAction : this.completeAction })
                this.isShowCertNumberBox = false
                this.phone = ''
                this.name = ''
                this.certNumber = ''
            }
        },
        async showPhoneCert(){
            const res = await this.$Axios.get('/api/phone_cert/auth');
            const target = res.data.target;
            const device = this.$cookies.get('device');

            let url;

            if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                url = 'https://obyungear-phonecert-test.ubiplus.co.kr/?device=' + device + '&target=' + target;
            } else {
                url = 'https://obyungear-phonecert.ubiplus.co.kr/?device=' + device + '&target=' + target;
            }

            window.completePhoneCert = (code, data) => {
                if(code == 0){
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, step: 3, isCert: true, completeAction : this.completeAction })
                } else {
                    console.log(data);
                    this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, step: 3, isCert: false, completeAction : this.completeAction })
                }
            }

            if(device === 'ios'){
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showWebView', url: url });
            }else {
                window.open(url);
            }
        },
        async getMyFamily(){
            const parameters = {};
            parameters.page = 1;
            const res = await this.$Axios.get('/api/member/family/mine', {params : parameters});
            const family = res.data.member_family;
            if(family.length > 0){
                this.family = family[0];
            }
        }
    },
    created() {
        if(this.step === 4){
            this.getMyFamily();
        }
    }
}
</script>

<style scoped>
.wrapper {
    display: flex;
    gap: 6px;
}

.contents {
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
}

.title {
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
}

input::placeholder {
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
    color: #bbbbbb;
}

.common_btn {
    height: 48px;
    margin-bottom: 40px;
    margin-top: 12px;
    border-radius: 12px;
    line-height: 48px;
    background-color: #210f03;
    text-align: center;
    color: var(--color-main);
    font-weight: 700;
    font-size: 14px;
}

.disable {
    background-color: #ebebeb;
    color: #d9d9d9;
}

.loader {
    display: flex;
    align-items: center;
    gap: 6px;
}

.big-circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #bbbbbb;
    transition: background-color 0.3s ease-in-out;
}

.dots-container {
    display: flex;
    gap: 6px;
}

.small-circle {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #d9d9d9;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}

.small-circle.active {
    opacity: 1;
}
</style>